'use strict';

angular.module('studies')
    .controller('StudyCreationFormController', ['$q', 'AccountManager', 'StudiesManager', 'ShareCrfUrl', 'ShareCrfApiErrorCodes', 'ShareCrfLanguageService', function($q, AccountManager, StudiesManager, ShareCrfUrl, ShareCrfApiErrorCodes, ShareCrfLanguageService) {
        var vm = this;

        vm.ready = false;

        vm.$onInit = function() {
            vm.data = {
                passwordExpiration: {
                    count: 1,
                    unit: 'year',
                },
            };

            vm.error = false;
            vm.submitted = false;
            vm.running = false;

            var urlWeb = ShareCrfUrl.getWww();
            var lang = ShareCrfLanguageService.getLanguage();

            var serviceTermsConditionsLink = {
                es: 'es/terminos-condiciones-servicio',
                en: 'service-terms-conditions',
            };

            vm.serviceTermsConditionsLink = urlWeb + serviceTermsConditionsLink[lang.code || 'es'];

            vm.submit = function(form) {
                vm.submitted = true;

                var promise = $q.resolve();

                if (form.$valid) {
                    vm.running = true;

                    promise = StudiesManager.create(vm.data)
                        .then(function() {
                            vm.running = false;

                            return vm.onSubmit();
                        })
                        .catch(function(error) {
                            vm.running = false;
                            vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                        });
                }

                return promise;
            };

            return AccountManager.init()
                .then(function() {
                    return StudiesManager.init();
                })
                .then(function() {
                    var loggedUser = AccountManager.getLoggedUser();

                    var numStudies = StudiesManager.countUserCreatedStudies(loggedUser.id);
                    var maxStudies = loggedUser.maxStudies;

                    vm.canCreateStudies = AccountManager.hasPermission('create studies');
                    vm.maxReached = maxStudies && numStudies >= maxStudies;

                    vm.hasAccess = vm.canCreateStudies && !vm.maxReached;

                    vm.ready = true;
                });
        };

    }]);
